'use client';

import { Box, SxProps, Theme } from '@mui/material';

interface OrangeLineProps {
  width?: string | number;
  height?: string | number;
  margin?: string;
  mx?: string | number;
  my?: string | number;
  mb?: string | number;
  mt?: string | number;
  ml?: string | number;
  mr?: string | number;
  sx?: SxProps<Theme>;
}

/**
 * Common Orange Line component - Reusable across multiple pages
 * Default Figma specs: 321x5px with center margin
 */
export default function OrangeLine({
  width,
  height,
  margin,
  mx,
  my,
  mt,
  mb,
  ml,
  mr,
  sx,
}: OrangeLineProps) {
  return (
    <Box
      sx={{
        width,
        height,
        backgroundColor: '#EB722E',
        margin,
        mx,
        my,
        mb,
        mt,
        ml,
        mr,
        ...sx,
      }}
    />
  );
}
